<!-- Rebate Request - Requester - Requester Decision -->
<div *ngIf="!isRequestSucceeded">
    <!-- Form Title [Primary] -->
    <h2 class="sectionTitle">Requester Decision</h2>
    <app-circular-request #circularsRequest (rebateRequestLoadedFlag)="onCircularsRequestLoadedFlag($event)">
    </app-circular-request>
</div>
<br>
<div class="form-container" *ngIf="!isRequestSucceeded" >
    <h2 class="sectionTitle">Decisions</h2>
  
    <div class="read-only-content">
        <div class="table-responsive">
            <table class="table table-bordered table-striped table-services">
                <thead>
                    <tr>
                        <th><span>From</span></th>
                        <th><span>To</span></th>
                        <th><span>Rebate Percentage</span></th>
                        <th><span>Notes</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let option of circularOptions; let i = index;">
                        <td>{{OriginsArr[i].Text}} </td>
                        <td>{{DestinationsArr[i].Text}} </td>
                        <td *ngIf="option.isGranted">
                            <span>{{OriginsArr[i].Percentage}}</span>
                        </td>
                        <td *ngIf="!option.isGranted">
                            <span>--</span>
                        </td>
                        <td>{{option.ApprovalNote}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
       <!-- <label>Print As PDF</label>
        <div>
            <a class="export-link" href="#" (click)="exportapdf($event)" >
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.25em" height="1.25em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z" fill="currentColor"/><path d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z" fill="currentColor"/></svg>
                <span>Print</span>
            </a>
        </div>-->
    </div>
</div>
<div *ngIf="!isRequestSucceeded" [class.read-only-content]="formMode == 2">
<h2 class="sectionTitle">Requester Decision</h2>
<form name="DecisionForm" [formGroup]="DecisionForm">
    <div class="form-container" #FirstStepDecision>
        <div class="form-section">
            <h4 class="section-title">Decision <span *ngIf="formMode == 0" class="red"> *</span></h4>
            
            <div class="form-group">
                <div class="custom-Radio">
                    <input type="radio" [disabled]="formMode == 2" formControlName="ActionType" id="rbtnDecisionIdAccept" value="1"
                        (change)="onDecisionChange()" />
                    <label for="rbtnDecisionIdAccept">Accept</label>
                </div>
                <div class="custom-Radio">
                    <input type="radio"[disabled]="formMode == 2" formControlName="ActionType" id="rbtnDecisionIdReject" value="3"
                        (change)="onDecisionChange()" />
                    <label for="rbtnDecisionIdReject">Reject</label>
                </div>
                <div *ngIf="isFormSubmitted && DecisionForm?.controls['ActionType']?.invalid"
                    class="red">
                    <span *ngIf="DecisionForm?.controls['ActionType']?.errors?.required">This
                        Field is Required</span>
                </div>
            </div>
        </div>
    </div>
    <div class="form-container">
        <div *ngIf="isReject" class="form-section">
            <h4 class="section-title">Reject</h4>
            <!-- Rejection Reason -->
            <div class="form-group">
                <label for="txtRejectionReason">Rejection Reason</label>
                <span *ngIf="formMode == 0" class="red"> *</span>
                <textarea formControlName="RejectionReason" id="txtRejectionReason" name="RejectionReason"
                    class="form-control"></textarea>
                <div *ngIf="isFormSubmitted && DecisionForm?.controls['RejectionReason']?.invalid"
                    class="red">
                    <span *ngIf="DecisionForm?.controls['RejectionReason']?.errors?.required">This
                        Field is Required</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isSubmitEnabled" class="form-group">
        <button type="button" class="btn SCAcustomBtn" Confirmation
            (confirmationClick)="submit()">Submit</button>
        <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
    </div>
</form>
</div>


<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>You have submitted your Decision Successfully</p>
        <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
    </div>
</div>
 
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-warning" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
                </g>
            </g>
        </svg>
        <p>Decision already submitted</p>
        <p>Go Back to <a routerLink="/myTasks">My Tasks</a></p>
    </div>
</div>

<div *ngIf="isRequestSucceeded && submitConfirmationMode == 3" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go to <a href="/English/Pages/ContactUs.aspx">Contact Us</a></p>
    </div>
</div>